import React, { useState } from "react";
import { FaBars } from "react-icons/fa";
// import logo from '../../Assets/logo/logo.svg';
import logo from "../../Assets/logo/OtL.png";
import { useNavigate, useLocation } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { MdAddIcCall } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import InquiryModal from "./InquiryModal";
import Building from "../../Assets/homeimgs/BuildingArchitecture.jpg";
import Highways from "../../Assets/homeimgs/Highways.jpg";
import Bridges from "../../Assets/homeimgs/Bridges.jpg";
import Railway from "../../Assets/homeimgs/Railway.jpeg";
import Water from "../../Assets/homeimgs/WaterResourses.jpg";
import Survey from "../../Assets/homeimgs/Survey.jpg";
import { IoIosArrowUp } from "react-icons/io";

const aboutData = [
  {
    name: "About Us",
    path: "/about",
  },
  {
    name: "The Founder Person, The MD",
    path: "/profile",
  },
];
const sectorsData = [
  {
    name: "Building & Architecture",
    image: Building,
    about:
      "We have successfully delivered township planning projects and have contributed significantly in urban planning.",
    about2:
      "We are generally carry out design of Residential building, Commercial building,Veterinary building, School building RHC & CHC building etc.We ",
    about3:
      "prioritize climate-responsive, innovative architecture that maximizes open space. Our commitment extends to designing structurally and functionally resilient units that enhance safety and minimize risks to human life and infrastructure during disasters.",
  },
  {
    name: "Highways",
    image: Highways,
    about:
      "Our firm has developed proficiency in planning & design, rehabilitation, and strengthening of all types of roads.",
    highwayTypes: {
      "National Highway":
        "National highways form the backbone of a country's transport network, connecting cities, states, and industrial hubs. Managed by NHAI, they drive economic growth and trade. Projects like the Golden Quadrilateral and Bharatmala Pariyojana enhance infrastructure and reduce travel time. With smart technology, eco-friendly construction, and expansions, India aims to strengthen connectivity and boost nationwide development.",
      "State Highway":
        "State highways are vital for regional connectivity, linking districts, cities, and major roads. Managed by state governments, they support economic growth and trade. Projects enhancing road widening, maintenance, and modernization improve infrastructure and reduce travel time. With smart technology, eco-friendly construction, and expansions, states aim to strengthen connectivity and boost overall development.",
      "ODR Highway":
        "Other District Roads (ODR) are essential for rural connectivity, linking villages, towns, and local markets to major highways. Managed by district authorities, they support regional trade and mobility. Projects focused on upgradation, maintenance, and sustainability enhance infrastructure and accessibility. With smart planning and expansions, ODR highways improve connectivity and drive local economic growth.",
    },
  },
  {
    name: "Bridges",
    image: Bridges,
    about:
      "Bridges, Flyovers, and ROB/RUB structures are integral to infrastructure development and urban planning.",
    about2:
      "Bridges, flyovers, road over bridges, interchanges, and ROB/RUB structures are vital components of road and railway infrastructure, playing a key role in urban development.",
    about3:
      "We have successfully designed and overseen the construction of numerous bridges nationwide, including key projects exceeding 2,500 meters. These feature well/pile foundations and advanced superstructures such as segmental post-tensioned box girders, pre-tensioned girders, RCC decks, prestressed girders, steel girders with RCC decks, and steel through girders.",
  },
  {
    name: "Railway",
    image: Railway,
    about:
      "We have designed and supervised the implementation of ballast-less tracks and track laying in tunnels.",
    about2:
      "The Government of India prioritizes railway capacity enhancement through network expansion, dedicated freight corridors, additional tracks, and gauge conversion. These initiatives aim to create a sustainable, cost-effective, efficient, and safe railway infrastructure, ensuring reliability and environmental sustainability while strengthening the nation’s transportation network.",
    about3:
      "Our expertise spans over 10,000 km of railway track design, construction, rehabilitation, yard capacity enhancement, dedicated industrial corridors, and railway infrastructure development for industries, along with railway operations and maintenance services.",
  },
  {
    name: "Water Resources",
    image: Water,
    about:
      "We specialize in the planning and design of water retention structures and water resource management strategies.",
    about2:
      "Water is becoming an increasingly valuable resource, making its management a critical challenge for engineers. Essential for both life and industry, significant river discharge is lost to the sea. To optimize utilization, efforts are focused on water retention through multiple barrages and weirs along river pathways, ensuring sustainable resource management.",
    about3:
      "We assess sub-surface water availability near rivers to explore the potential for water extraction through radial wells. Additionally, we conduct drawdown tests to evaluate borewell infiltration capacity, ensuring efficient groundwater utilization and sustainable water resource management.",
  },
  {
    name: "Survey",
    image: Survey,
    about:
      "Our team provides digital mapping, land assessment, and survey solutions for various projects.",
    about2:
      "A topographic survey is essential for any infrastructure project, as its precision forms the foundation for effective engineering design.",
    about3:
      "Our firm excels in topographical surveys, having conducted extensive surveys across India using advanced technology and software. We have also leveraged LiDAR technology mounted on vehicles to survey challenging terrains with high accuracy. Our survey expertise covers a wide range of projects, including land subdivision, mining exploration, tunnel construction, major infrastructure, and linear project surveys for roads and railways. We also specialize in forest surveying and excel in data transfer, processing, and interpretation with precision and efficiency.",
  },
];
const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showAboutDropdown, setShowAboutDropdown] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [isSectorOpen, setIsSectorOpen] = useState(false);
  const [isAboutOpen, setIsAboutOpen] = useState(false);
  const handleMouseEnter = () => {
    setShowDropdown(true);

    setIsHovered(true);
  };

  const handleMouseEnter2 = () => {
    setShowAboutDropdown(true);
    setIsHovered2(true);
  };
  const handleMouseLeave = () => {
    setShowDropdown(false);

    setIsHovered(false);
  };
  const handleMouseLeave2 = () => {
    setShowAboutDropdown(false);
    setIsHovered2(false);
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const getLinkClass = (path) => {
    return location.pathname === path
      ? "text-base font-semibold text-[#1522ED] cursor-pointer tracking-wide"
      : "text-base font-semibold hover:text-[#1522ED] cursor-pointer tracking-wide";
  };

  const [open, setOpen] = useState(false);

  const handleAddOpen = () => {
    setOpen(true);
  };

  const handleModalClose = () => {
    setOpen(false);
  };
  const handleNavigate = (sector) => {
    navigate("/sectors", { state: { sector } });
    setShowDropdown(false);
    setIsHovered(false);
    // setShowAboutDropdown(false);
  };

  const handleNavigate2 = (sector) => {
    navigate(`${sector.path}`);
    setShowAboutDropdown(false);
    setIsHovered2(false);
    // setShowDropdown(false);
  };

  return (
    <>
      <nav className="hidden lg:block bg-[#1522ED] text-white px-6 md:px-16 py-2">
        <div className="mx-auto flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <FaLocationDot size={15} />
            <span className="text-sm tracking-wide font-semibold">
              Plot No-GA-822, B-3, Kalinga Nagar, Ghatikia Khandagiri,
              Bhubaneswar, 751003
            </span>
          </div>

          <div className="flex space-x-4 items-center">
            <MdAddIcCall size={15} />
            <span className="text-sm tracking-wide font-semibold">
              +91 8249525997 , 9439199089
            </span>
          </div>
        </div>
      </nav>
      {/* Navbar */}
      <nav className="bg-[#fffefc] text-[#26232A] px-6 md:px-16 py-2 shadow-2xl">
        <div className=" mx-auto flex items-center justify-between">
          {/* 1st Section - Logo */}
          <div className="flex justify-center items-center">
            <img src={logo} alt="baisaly-logo" className="w-[4rem]" />
            <div className="ml-2 ">
              <p className="capitalize text-[#1522ED] tracking-wide font-semibold">
                OTL CONSULTANCY SERVICE PRIVATE LIMITED
              </p>
              <p className="capitalize text-red-500 tracking-wide font-semibold">
                (NABL ACCREDITED LABORATORY)
              </p>
            </div>
          </div>

          {/* Middle Section - Page Links (hidden on small screens) */}
          <div className="hidden xl:flex space-x-8">
            <div onClick={() => navigate("/")} className={getLinkClass("/")}>
              <h1 className="text-sm font-extrabold">Home</h1>
            </div>
            <div
              className="relative cursor-pointer hover:text-[#1522ED]"
              onMouseEnter={handleMouseEnter2}
              onMouseLeave={handleMouseLeave2}
            >
              <div className="flex items-center group">
                <div className={getLinkClass("/about")}>
                  <h1 className="text-sm font-extrabold">About</h1>
                </div>
                <div
                  className={
                    getLinkClass("/about") +
                    "group-hover:rotate-180 transform transition duration-500"
                  }
                >
                  <IoIosArrowUp
                    className={` transform transition-transform duration-300 ${
                      isHovered2 ? "rotate-0" : "rotate-180"
                    }`}
                  />
                </div>
              </div>
              {showAboutDropdown && (
                <div className="absolute top-full left-0 mt-0 w-64 bg-white shadow-lg rounded-md z-50">
                  {aboutData.map((sector, index) => {
                    return (
                      <>
                        <div
                          className="px-4 py-2 hover:bg-gray-200 cursor-pointer text-black hover:text-[#1522ed]"
                          onClick={() => {
                            handleNavigate2(sector);
                          }}
                        >
                          <strong className="text-sm font-extrabold">
                            {sector.name}
                          </strong>
                        </div>
                        {index === aboutData.length - 1 ? null : <hr />}
                      </>
                    );
                  })}
                </div>
              )}
            </div>
            <div
              onClick={() => navigate("/services")}
              className={getLinkClass("/services")}
            >
              <h1 className="text-sm font-extrabold">Services</h1>
            </div>
            <div
              className="relative cursor-pointer hover:text-[#1522ED]"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <div className="flex items-center group">
                <div className={getLinkClass("/sectors")}>
                  <h1 className="text-sm font-extrabold">Sectors</h1>
                </div>
                <div
                  className={
                    getLinkClass("/sectors") +
                    "group-hover:rotate-180 transform transition duration-500"
                  }
                >
                  <IoIosArrowUp
                    className={` transform transition-transform duration-300 ${
                      isHovered ? "rotate-0" : "rotate-180"
                    }`}
                  />
                </div>
              </div>
              {showDropdown && (
                <div className="absolute top-full left-0 mt-0 w-64 bg-white shadow-lg rounded-md z-50">
                  {sectorsData.map((sector, index) => {
                    return (
                      <>
                        <div
                          className="px-4 py-2 hover:bg-gray-200 cursor-pointer text-black hover:text-[#1522ed]"
                          onClick={() => {
                            handleNavigate(sector);
                          }}
                        >
                          <strong className="text-sm font-extrabold">
                            {sector.name}
                          </strong>
                        </div>
                        {index === sectorsData.length - 1 ? null : <hr />}
                      </>
                    );
                  })}
                </div>
              )}
            </div>
            <div
              onClick={() => navigate("/careers")}
              className={getLinkClass("/careers")}
            >
              <h1 className="text-sm font-extrabold">Careers</h1>
            </div>
            <div
              onClick={() => navigate("/projects")}
              className={getLinkClass("/projects")}
            >
              <h1 className="text-sm font-extrabold">Gallery</h1>
            </div>{" "}
            <div
              onClick={() => navigate("/contact")}
              className={getLinkClass("/contact")}
            >
              <h1 className="text-sm font-extrabold">Contact</h1>
            </div>
          </div>

          {/* 3rd Section - Login Button */}
          <div className="hidden xl:block">
            <button
              onClick={handleAddOpen}
              className="tracking-wide bg-[#1522ED] text-white font-bold py-2 px-4 rounded"
            >
              <h1 className="text-sm font-extrabold">Inquiry</h1>
            </button>
          </div>
          {open && <InquiryModal onClose={handleModalClose} />}
          {/* Hamburger Menu for Small Screens */}
          <div className="xl:hidden">
            <FaBars
              onClick={toggleSidebar}
              size={24}
              className="cursor-pointer"
            />
          </div>
        </div>
      </nav>

      {/* Sidebar for Small Screens */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50">
          <div className="fixed top-0 left-0 w-64 h-full bg-white shadow-md">
            <div className="p-4">
              <button
                className="text-black text-lg font-bold mb-8 float-right"
                onClick={toggleSidebar}
              >
                <IoClose size={25} className="text-[#1522ED]" />
              </button>

              <ul className="space-y-4 text-lg">
                <li
                  onClick={() => {
                    navigate("/");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/")}
                >
                  Home
                </li>
                <li
                  className="cursor-pointer flex items-center "
                  onClick={() => setIsAboutOpen(!isAboutOpen)}
                >
                  <span className={getLinkClass("/about")}>About</span>
                  <IoIosArrowUp
                    className={`transition-transform duration-300 ${
                      isAboutOpen ? "" : "rotate-180"
                    }`}
                  />
                </li>

                {isAboutOpen && (
                  <ul className="ml-4 space-y-2">
                    {aboutData.map((sector, index) => {
                      return (
                        <>
                          <li
                            className=" hover:bg-gray-200 cursor-pointer text-black hover:text-[#1522ed]"
                            onClick={() => {
                              handleNavigate2(sector);
                              toggleSidebar();
                            }}
                          >
                            <h1 className="text-base font-semibold hover:text-[#1522ED] cursor-pointer tracking-wide">
                              {sector.name}
                            </h1>
                          </li>
                        </>
                      );
                    })}
                  </ul>
                )}
                <li
                  onClick={() => {
                    navigate("/services");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/services")}
                >
                  Services
                </li>

                {/* Sectors Dropdown in Sidebar */}
                <li
                  className="cursor-pointer flex items-center "
                  onClick={() => setIsSectorOpen(!isSectorOpen)}
                >
                  <span className={getLinkClass("/sectors")}>Sectors</span>
                  <IoIosArrowUp
                    className={`transition-transform duration-300 ${
                      isSectorOpen ? "" : "rotate-180"
                    }`}
                  />
                </li>

                {isSectorOpen && (
                  <ul className="ml-4 space-y-2">
                    {sectorsData.map((sector, index) => {
                      return (
                        <>
                          <li
                            className=" hover:bg-gray-200 cursor-pointer text-black hover:text-[#1522ed]"
                            onClick={() => {
                              handleNavigate(sector);
                              toggleSidebar();
                            }}
                          >
                            <h1 className="text-base font-semibold hover:text-[#1522ED] cursor-pointer tracking-wide">
                              {sector.name}
                            </h1>
                          </li>
                        </>
                      );
                    })}
                  </ul>
                )}

                <li
                  onClick={() => {
                    navigate("/careers");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/careers")}
                >
                  Careers
                </li>
                <li
                  onClick={() => {
                    navigate("/projects");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/projects")}
                >
                  Gallery
                </li>
                <li
                  onClick={() => {
                    navigate("/contact");
                    toggleSidebar();
                  }}
                  className={getLinkClass("/contact")}
                >
                  Contact
                </li>
              </ul>

              <button
                onClick={handleAddOpen}
                className="tracking-wide mt-8 bg-[#1522ED] text-white font-bold py-2 px-4 rounded"
              >
                Inquiry
              </button>
              {open && <InquiryModal onClose={handleModalClose} />}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
